import { Plan } from "./plan";

export class StripeSubscription {
    public customerId: string;
    public start: Date;
    public status: string;
    public plan: Plan

    constructor(obj: any) {
        this.customerId = obj && obj.CustomerId || '';
        this.start = obj && obj.Start || null;
        this.status = obj && obj.Status || '';
        this.plan = obj && obj.Plan && new Plan().deserialize(obj.Plan) || null;
    }
}